import { render, staticRenderFns } from "./Revisions.vue?vue&type=template&id=3e0fc4bc&scoped=true&"
import script from "./Revisions.vue?vue&type=script&lang=js&"
export * from "./Revisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0fc4bc",
  null
  
)

export default component.exports